const listeners = new Set();

export const subscribeSessionWarning = (listener) => {
  if (typeof listener !== "function") {
    return () => {};
  }

  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const emitSessionWarning = (payload = {}) => {
  listeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Session warning listener failed", error);
    }
  });
};
